<template>
    <div class="column is-2 box-shadow-v has-background-greyBG">
        <div class="is-inline-flex has-text-primary p-2">
            <h6 class="is-subtitle-size is-primary pl-3 mr-4">
                {{ $t("note-list.notes") }}
            </h6>
            <Icon family="fal" name="fa-sticky-note" />
        </div>
        <div class="notes-container mt-2 mb-1 px-1">
            <template v-for="note in notes">
                <Note :note="note" :key="note.id" />
            </template>
        </div>
        <div class="is-flex is-justify-content-center">
            <button
                class="button has-text-centered"
                @click="toggleTypeSelector"
            >
                <span>{{ $t("note-list.add-note") }}</span>
                <Icon family="fal" name="fa-plus" />
            </button>
        </div>
        <NoteTypeSelector
            v-if="typeSelectorOpen"
            @close="toggleTypeSelector"
            @selected="openSelectedTypeBuilder"
        />
        <NoteBuilder
            v-if="noteBuilderOpen"
            :type="noteBuilderType"
            @close="closeNoteBuilder"
        />
    </div>
</template>

<script>
import Note from "./Note";
import NoteTypeSelector from "./NoteTypeSelectorModal";
import NoteBuilder from "./NoteBuilder";
import { mapGetters } from "vuex";

export default {
    name: "notes-list",
    components: {
        Note,
        NoteTypeSelector,
        NoteBuilder,
    },
    data() {
        return {
            typeSelectorOpen: false,
            noteBuilderOpen: false,
            noteBuilderType: "",
        };
    },
    computed: {
        ...mapGetters("notes", ["getNotes"]),
        notes() {
            return this.getNotes;
        },
    },
    methods: {
        toggleTypeSelector() {
            this.typeSelectorOpen = !this.typeSelectorOpen;
        },
        closeNoteBuilder() {
            this.noteBuilderOpen = false;
        },
        openSelectedTypeBuilder(type) {
            this.typeSelectorOpen = false;
            this.noteBuilderOpen = true;
            this.noteBuilderType = type;
        },
    },
};
</script>

<style lang="scss" scoped>
.notes-container {
    max-height: 76vh;
    overflow-y: auto;
}
</style>